import * as React from 'react';
import {
	INSIGHT_ICON_BLUE,
	PRODUCTIVITY_ICON_BLUE,
	SCALABILITY_ICON_BLUE,
	TA_QUESTIONS_PREVIEW_IMG,
	TECH_STACK_ICON_BLUE,
	WIX_ANSWERS_LOGO_WHITE,
} from '../../ta-shared';

type TaQuestionsPreviewProps = {
	onUpdateStep: (value?: string) => void;
};

export const TaQuestionsPreview = ({
	onUpdateStep,
}: TaQuestionsPreviewProps) => {
	const handleClick = () => {
		onUpdateStep();
	};

	return (
		<div className='ta-questions-preview_container'>
			<div className='ta-questions-preview_left-section'>
				<div className='ta-questions-preview_logo'>
					<img src={WIX_ANSWERS_LOGO_WHITE} alt='Wix Answers logo' />
				</div>
				<div className='ta-questions-preview_title'>
					What you’ll get
				</div>
				<div className='ta-questions-preview_subtitle'>
					A comprehensive report on your tech stack's strengths and
					weaknesses with tips on how to improve your support
					operations for 2021.
				</div>
				<div className='ta-questions-preview_img-container'>
					<img
						src={TA_QUESTIONS_PREVIEW_IMG}
						alt='questions preview'
					/>
				</div>
			</div>
			<div className='ta-questions-preview_right-section'>
				<div className='ta-questions-preview_info'>
					<div className='ta-questions-preview_info-title'>
						<img src={TECH_STACK_ICON_BLUE} alt='' />
						<span>Tech Stack</span>
					</div>
					<div className='ta-questions-preview_info-text'>
						Discover whether your platform provides agents and
						customers with the right tools.
					</div>
					<div className='ta-questions-preview_info-title'>
						<img src={PRODUCTIVITY_ICON_BLUE} alt='' />
						<span>Productivity</span>
					</div>
					<div className='ta-questions-preview_info-text'>
						Understand your agents' performance, capabilities to
						fuel efficiency & automations.
					</div>
					<div className='ta-questions-preview_info-title'>
						<img src={SCALABILITY_ICON_BLUE} alt='' />
						<span>Scalability</span>
					</div>
					<div className='ta-questions-preview_info-text'>
						Evaluate the flexibility & adaptability of your platform
						when expanding your business.
					</div>
					<div className='ta-questions-preview_info-title'>
						<img src={INSIGHT_ICON_BLUE} alt='' />
						<span>Insights</span>
					</div>
					<div className='ta-questions-preview_info-text'>
						Assess if you’re missing the full picture of your
						customers’ pains, identify gaps, & more.
					</div>
					<button
						className='ta-questions-preview_button'
						onClick={handleClick}
					>
						Start Now
					</button>
				</div>
			</div>
		</div>
	);
};
